import React, { useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'

import styled, { useTheme } from 'styled-components'

import { viewProductInTracker } from 'actions/tracker'

import { RESULTS_DATA_ATTRIBUTE_IDS } from 'constants/data_attributes/product_database/results'
import { COMMON_TOOLTIPS } from 'constants/product_database/tooltips'

import { productType } from 'types/product'

import { CheckmarkIcon } from 'icons/CheckmarkIcon/CheckmarkIcon'
import { LoadingIcon, Tooltip } from '@junglescout/edna'

import { PlusCircleIcon } from 'icons/PlusCircleIcon/PlusCircleIcon'
import { NakedButton } from 'ui_elements/NakedButton/NakedButton'
import { AddGroupDropdown } from './AddGroupDropdown'

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;

  &:hover {
    background-color: ${props => props.theme.colors.coolGrey200};
  }
`
const StyledNakedButton = styled(NakedButton)`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;

  &:hover {
    background-color: ${props => props.theme.colors.coolGrey200};
  }
`

export const AddGroupButton = ({ product }) => {
  const anchor = useRef()
  const dispatch = useDispatch()
  const { colors } = useTheme()

  const { t } = useTranslation(['product_database'])

  const allTrackedProducts = useSelector(
    state => state.globalData?.allTrackedProducts
  )
  const pendingTracks = useSelector(state => state.tracker.pendingTracks)

  const [isOpen, setIsOpen] = useState(false)

  const { variants, id } = product

  const targetIds =
    variants?.length > 0 ? variants.map(variant => variant.id) : [id]

  const isLoadingTracker = pendingTracks.some(productId =>
    targetIds.some(targetId => productId === targetId)
  )

  if (isLoadingTracker) {
    return (
      <IconWrapper>
        <LoadingIcon size="16px" color="grey900" />
      </IconWrapper>
    )
  }

  const isTracked = allTrackedProducts.some(productId =>
    targetIds.some(targetId => productId === targetId)
  )

  if (isTracked) {
    return (
      <Tooltip side="top" content={COMMON_TOOLTIPS.addToTrackerButton.tracked}>
        <IconWrapper>
          <CheckmarkIcon
            size="16px"
            color={colors.green500}
            onClick={() => dispatch(viewProductInTracker(id))}
          />
        </IconWrapper>
      </Tooltip>
    )
  }

  return (
    <>
      <div ref={anchor}>
        <Tooltip
          content={t(
            'product_database:DatabaseTable.dropdownActions.addToTracker',
            'Add to Product Tracker'
          )}
          side="top">
          <StyledNakedButton
            data-id={RESULTS_DATA_ATTRIBUTE_IDS.Buttons.AddToTracker}
            onClick={() => {
              setIsOpen(true)
            }}>
            <PlusCircleIcon size="16px" color={colors.grey900} />
          </StyledNakedButton>
        </Tooltip>
      </div>

      <AddGroupDropdown
        product={product}
        popperAnchor={anchor.current}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />
    </>
  )
}

AddGroupButton.propTypes = {
  product: productType.isRequired
}
